import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../assets/logo_site.png?inline';
import { PlaneIcon } from './Icons';
import { fetchSystemLinks } from '../services/api';
import { useTelegramModal } from '../context/TelegramModalContext';

function Footer() {
  const currentYear = new Date().getFullYear();
  const [botLink, setBotLink] = useState('');
  const { openTelegramModal } = useTelegramModal();

  useEffect(() => {
    fetchSystemLinks()
      .then(links => setBotLink(links.bot || ''))
      .catch(() => setBotLink(''));
  }, []);

  const handleBotClick = (e) => {
    if (!botLink) {
      e.preventDefault();
      return;
    }
    e.preventDefault();
    openTelegramModal(botLink);
  };

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__content">
          <Link to="/" className="logo footer__logo">
            <span className="logo__text">
              <span className="logo__protocol">PROTOCOL</span>
            </span>
            <div className="logo-frame footer__logo-frame">
              <img src={logoImage} alt="Logo" width="56" height="56" />
            </div>
            <span className="logo__goida">GOIDA</span>
          </Link>
          
          <nav className="footer__nav">
            <Link to="/" className="footer__link">Главная</Link>
            <Link to="/proxy" className="footer__link">Прокси</Link>
            <Link to="/terms-policy" className="footer__link">Условия и политика</Link>
          </nav>

          <div className="footer__social-wrapper">
            <a 
              href={botLink || '#'} 
              className="footer__social-btn"
              onClick={handleBotClick}
              aria-label="Telegram Bot"
            >
              <div className="footer__social-icon">
                <PlaneIcon size={22} />
              </div>
              <span className="footer__social-text">Перейти к боту</span>
            </a>
          </div>
        </div>
        
        <div className="footer__bottom">
          <p className="footer__copyright">
            <span className="footer__copyright-year">&copy; {currentYear}</span>
            <span className="footer__copyright-brand">ProtocolGOIDA</span>
            <span className="footer__copyright-separator">•</span>
            <span className="footer__copyright-note">Все права защищены</span>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
